// web/src/config.js
//
// PENTING: file ini ikut ter-bundle ke web app yang bisa dibuka siapa pun di
// jaringan yang sama, jadi JANGAN menaruh rahasia apa pun di sini (URL
// webhook, token, password). Dulu di sini ada 15 URL webhook + webhook backup
// index - sekarang webhook penyimpanan didapat per akun saat login, dan backup
// index dikirim lewat bot (butuh login), bukan langsung ke webhook.

// Ukuran maksimal per potongan (chunk). Batas ini mengikuti limit upload
// bawaan Discord untuk server yang TIDAK di-boost (bukan soal akun Nitro
// kamu pribadi, ini limit per-server, ditentukan oleh boost level server).
//
// Dipakai 19MB. Sudah dites langsung ke webhook: 20MB lolos, 24MB ditolak
// (413), jadi 19MB menyisakan ruang sedikit di bawah batas. File lama yang
// dipotong 9.5MB tetap terbaca (ukuran potongan tidak disimpan di index).
// Harus SAMA dengan CHUNK_SIZE di discord-bot/.env.
// 19 * 1024 * 1024 = 19922944 bytes
//
// Ini hanya ukuran bawaan. Ukuran yang dipakai diatur per akun di bot
// (Setelan > Ukuran potongan upload) dan turun otomatis kalau Discord menolak.
export const CHUNK_SIZE = 19922944;

// Alamat REST API bot Discord (folder /discord-bot).
//
// DIHITUNG OTOMATIS dari host yang dipakai BROWSER untuk membuka halaman
// ini (window.location.hostname) - bukan di-hardcode "localhost". Jadi SATU
// bot + SATU web app yang sama bisa diakses dengan cara apa pun (localhost di
// komputer sendiri, IP LAN, ATAU IP/hostname Tailscale) tanpa perlu ganti
// config: kalau halaman dibuka lewat http://192.168.1.5:3000/web, otomatis
// memanggil bot di http://192.168.1.5:4000. Port bot (4000) HARUS tetap sama
// dengan PORT di discord-bot/.env.
//
// Kalau web TIDAK dibuka di port 3000 (yaitu lewat domain publik, Caddy
// https), bot dipanggil di alamat yang sama dengan awalan /api (Caddy
// meneruskan hanya route yang dibutuhkan halaman /web/drive).
export const BOT_API_URL = typeof window === "undefined"
  ? "http://localhost:4000"
  : window.location.port === "3000"
    ? `${window.location.protocol}//${window.location.hostname}:4000`
    : `${window.location.origin}/api`;

// Jeda (ms) setelah perubahan TERAKHIR sebelum index otomatis dikirim
// sebagai backup ke Discord. Mencegah spam upload saat banyak perubahan
// beruntun (misal saat upload banyak file sekaligus).
export const BACKUP_DEBOUNCE_MS = 5000;
